import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X, Expand } from "lucide-react";
import { GALLERY } from "@/data/site";
import { Reveal } from "@/components/Reveal";

export const WorkGallery = () => {
  const [active, setActive] = useState(null);

  return (
    <section className="bg-[#0B0F19]" data-testid="work-section">
      <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8 lg:py-24">
        <Reveal>
          <div className="flex flex-wrap items-end justify-between gap-4">
            <div>
              <p className="font-mono-tech text-xs font-semibold uppercase tracking-[0.35em] text-[#FF5B00]" data-testid="work-kicker">
                Our Work
              </p>
              <h2 className="mt-4 font-display text-3xl font-bold uppercase leading-tight tracking-tight text-[#F8FAFC] sm:text-4xl lg:text-5xl" data-testid="work-heading">
                Real Projects. Real Results.
              </h2>
              <div className="mt-5 h-1 w-16 bg-[#FF5B00]" />
            </div>
            <p className="font-display text-xl italic text-[#F8FAFC] sm:text-2xl" data-testid="work-tagline">
              Quality Work You Can Depend On.
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5" data-testid="work-grid">
          {GALLERY.map((g, i) => (
            <Reveal key={g.src} delay={i * 0.08}>
              <button
                onClick={() => setActive(g)}
                className="group relative block w-full overflow-hidden"
                data-testid={`work-item-${g.src.split("/").pop().split(".")[0]}`}
              >
                <img
                  src={g.src}
                  alt={g.alt}
                  className="aspect-[3/4] w-full object-cover transition-transform duration-700 group-hover:scale-[1.06]"
                />
                <div className="absolute inset-0 flex items-end justify-between bg-gradient-to-t from-[#0B0F19]/90 via-transparent to-transparent p-3 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                  <span className="font-mono-tech text-[10px] uppercase tracking-[0.15em] text-[#F8FAFC]">{g.cat}</span>
                  <Expand className="h-4 w-4 text-[#FF5B00]" />
                </div>
              </button>
            </Reveal>
          ))}
        </div>
      </div>

      <AnimatePresence>
        {active && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="fixed inset-0 z-[100] flex items-center justify-center bg-[#0B0F19]/95 p-4 backdrop-blur-md sm:p-10"
            onClick={() => setActive(null)}
            data-testid="lightbox-overlay"
          >
            <button
              className="absolute right-5 top-5 flex h-11 w-11 items-center justify-center border border-[#334155] text-[#F8FAFC] transition-colors duration-300 hover:border-[#FF5B00] hover:text-[#FF5B00]"
              onClick={() => setActive(null)}
              data-testid="lightbox-close"
              aria-label="Close"
            >
              <X className="h-5 w-5" />
            </button>
            <motion.img
              initial={{ scale: 0.92, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.95, opacity: 0 }}
              transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
              src={active.src}
              alt={active.alt}
              className="max-h-full max-w-full border border-[#1E293B] object-contain"
              onClick={(e) => e.stopPropagation()}
              data-testid="lightbox-image"
            />
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};
